import { JsonEditorOptions } from "ang-jsoneditor";
import { TranslocoService } from "@ngneat/transloco";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class JsonEditorService {

  constructor(private i18n: TranslocoService) {}

  public buildFormEditorOptions() {
    let editorOptions = new JsonEditorOptions();
    editorOptions.mode = 'code';
    editorOptions.statusBar = false;
    editorOptions.search = false;
    editorOptions.enableSort = false;
    editorOptions.enableTransform = false;
    editorOptions.navigationBar = false;
    editorOptions.language = this.i18n.getActiveLang();

    return editorOptions;
  }

  public buildReadonlyEditorOptions() {
    let editorOptions = new JsonEditorOptions();
    editorOptions.mode = 'view';
    editorOptions.mainMenuBar = false;
    editorOptions.navigationBar = false;
    editorOptions.expandAll = true;
    editorOptions.language = this.i18n.getActiveLang();

    return editorOptions;
  }

}
